import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@workbook/shared/tokens.css';
import './styles/fonts.css';
import './styles/components.css';
import './styles/app.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { Toaster } from './components/Toast';
import { DialogHost } from './components/DialogHost';
import { PromptDialog } from './components/PromptDialog';
import { Announcer } from './components/LiveRegion';
import { ErrorBoundary } from './components/ErrorBoundary';
import { queryClient } from './modules/query';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/*
      🔴 THE PROVIDER WRAPS EVERYTHING, INCLUDING SIGN-IN — ERP Phase 1a increment 7.

      ⚠️ Not around the router alone. `App` decides between the sign-in form, the company picker and
      the product BEFORE the router exists, and a query fired from any of those would throw for want
      of a client. 🔬 One cache for the whole application is also the point: the membership list the
      picker fetches is the one the shell's company button reads.
    */}
    <QueryClientProvider client={queryClient}>
      {/*
      DS-6a: every root is inside a crash screen (a throw no longer blanks the page), one live region the whole app
      speaks through (useAnnounce), and one toast stack (toast.success).
    */}
      <Announcer>
        <ErrorBoundary title="Workbook hit a problem it could not show.">
          <App />
        </ErrorBoundary>
        <Toaster />
        {/* DS-8: where useConfirm/usePrompt questions are drawn — prompts too, which the till asks with no network. */}
        <DialogHost prompt={PromptDialog} />
      </Announcer>
    </QueryClientProvider>
  </StrictMode>,
);
